import { render, staticRenderFns } from "./UserSettingEdit.vue?vue&type=template&id=459d1694&"
import script from "./UserSettingEdit.vue?vue&type=script&lang=js&"
export * from "./UserSettingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports